export const validateDate = (dateStr: string, min: string, max: string) => {
    const selectedDate = new Date(dateStr);
    const minDate = new Date(min);
    const maxDate = new Date(max);

    return selectedDate >= minDate && selectedDate <= maxDate;
};